export default "__VITE_ASSET__CJ$IdH5Q__"